import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'button',
  ];

  static values = {
    url: String,
  };

  connect() {
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener('click', () => { this.redirect(); });
    }
  }

  redirect() {
    if (this.hasUrlValue) {
      window.open(this.urlValue, '_blank');
    }
  }
}
